<!-- Announce the loading state to assistive tech; the visual skeletons below are
     decorative (WCAG 4.1.3 Status Messages). Mirrors the cm-spinner pattern. -->
<span class="sr-only" role="status">{{ loadingText() }}</span>
@if (preset() === 'section') {
  <cm-skeleton-section [animation]="animation()" />
} @else if (preset() === 'form') {
  <cm-skeleton-form [animation]="animation()" />
} @else if (preset() === 'form-flat') {
  <cm-skeleton-form-flat [animation]="animation()" />
} @else if (preset() === 'form-field') {
  <cm-skeleton-form-field [animation]="animation()" />
} @else if (preset() === 'header') {
  <cm-skeleton-header [animation]="animation()" />
} @else if (preset() === 'page') {
  <cm-skeleton-page [animation]="animation()" />
} @else if (preset() === 'navbar') {
  <cm-skeleton-navbar [animation]="animation()" />
} @else if (preset() === 'full-layout') {
  <cm-skeleton-full-layout [animation]="animation()" />
} @else if (preset() === 'table') {
  <cm-skeleton-table
    [animation]="animation()"
    [tableRows]="tableRows()"
    [tableColumns]="tableColumns()"
  />
} @else if (preset() === 'stat-tiles') {
  <cm-skeleton-stat-tiles [animation]="animation()" [tileCount]="tileCount()" />
} @else if (preset() === 'team-workload') {
  <cm-skeleton-team-workload
    [animation]="animation()"
    [cardCount]="cardCount()"
    [rowsPerCard]="rowsPerCard()"
    [teamRows]="teamRows()"
  />
} @else if (preset() === 'profile') {
  <cm-skeleton-profile [animation]="animation()" />
} @else {
  @for (item of [].constructor(effectiveCount()); track $index) {
    <div
      [class]="className()"
      [style.width]="width()"
      [style.height]="height()"
      [style.border-radius]="borderRadius()"
    ></div>
  }
}
